import { preciseRound } from '@frontend/shared/Util.js';

export function bigDollarFormat(value, precision) {
  if (precision === undefined) {
    precision = 2;
  }
  if (value >= 1000000000000) {
    return `$${preciseRound((value / 1000000000000), precision)}t`;
  }
  if (value >= 1000000000) {
    return `$${preciseRound((value / 1000000000), precision)}b`;
  }
  if (value >= 1000000) {
    return `$${preciseRound((value / 1000000), precision)}m`;
  }
  return `$${value.toLocaleString()}`;
}
